import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HomePage } from "@/pages/HomePage";
import { QuestionnairePage } from "@/pages/QuestionnairePage";
import { ResultsPage } from "@/pages/ResultsPage";
import { ActionPlanPage } from "@/pages/ActionPlanPage";

function App() {
  return (
    <AppProvider>
      <div className="min-h-screen flex flex-col bg-background">
        <BrowserRouter>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/questionnaire" element={<QuestionnairePage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/action-plan" element={<ActionPlanPage />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </AppProvider>
  );
}

export default App;
